import { Badge, Flex, Paper, SimpleGrid, Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useTransactionFromDocumentModalContext } from '../TransactionFromDocumentModalContext';

export const DocumentList = () => {
	const {
		documents,
		selectedDocumentIndex: selectedIndex,
		setSelectedDocumentIndex: onSelectDocument,
	} = useTransactionFromDocumentModalContext();
	const tCapManage = useTranslationCapManage();

	if (documents.length === 0) {
		return null;
	}

	return (
		<div>
			<Text size="md" fw={600} mb="sm">
				{tCapManage('transactions.add_from_document.uploaded')} ({documents.length})
			</Text>
			<SimpleGrid cols={6} spacing="sm" verticalSpacing="sm">
				{documents.map((doc, index) => {
					const isSelected = index === selectedIndex;

					return (
						<Paper
							key={index}
							p="sm"
							withBorder
							sx={(theme) => ({
								cursor: 'pointer',
								borderColor: isSelected
									? theme.colors.blue[6]
									: theme.colors.gray[4],
							})}
							onClick={() => onSelectDocument(index)}
						>
							<Flex direction="column" gap="xs">
								<Flex align="center" gap="xs">
									<Icon variant="document-v3" size="md" />
									<Text size="sm" fw={500} lineClamp={1}>
										{doc.file.name}
									</Text>
								</Flex>
								<Badge
									size="sm"
									variant="outline"
									color="gray"
									styles={{
										root: {
											textTransform: 'none',
											fontWeight: 400,
										},
									}}
								>
									{tCapManage('transactions.add_from_document.agreement')}
								</Badge>
							</Flex>
						</Paper>
					);
				})}
			</SimpleGrid>
		</div>
	);
};
